module.exports = __webpack_public_path__ + "img/ninos.5eb3be48.png";